import { reset, SubmissionError } from "redux-form";
import i18next from "i18next";

import { behindText } from "helpers";

import { DELETE_POST_SUCCESS, deleteReviewVodApi } from "actions/post.action";

import { toastr } from "components/toastr";

export const reviewDeleteValidateSubmit = async (values, dispatch, { close, form }) => {
	const reason = values.del_reason ? values.del_reason.trim() : "";
	if (!reason || reason === "" || reason.length < 5 || reason.length > 200) {
		throw new SubmissionError({
			_error: i18next.t("오류") + behindText(),
		});
	}

	try {
		const response = await deleteReviewVodApi(values);

		// 다시보기 사유 기입 삭제 실패
		if (response.RESULT !== 1) {
			close();

			toastr.success(i18next.t(response.MSG), {
				timeOut: 3000,
			});
			return;
		}

		response.title_no = values.title_no;
		dispatch({
			type: DELETE_POST_SUCCESS,
			payload: response,
		});

		toastr.success(i18next.t("VOD가 삭제되었습니다."), {
			timeOut: 3000,
		});

		// 팝업 종료
		close();

		//form 리셋
		dispatch(reset(form));
	} catch (error) {
		toastr.error(error.message, {
			timeOut: 2000,
		});
	}
};
